import { ExpansionPanelSummary } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

interface AccordionSummaryProps {
  disableRootStyles?: boolean;
}

const AccordionSummary = withStyles(theme => ({
  root: (props: AccordionSummaryProps) =>
    (props.disableRootStyles ?? false)
      ? {}
      : {
          borderRadius: 5,
          padding: theme.spacing(1.25, 1.25, 1.25, 3.5),
          '&:hover': {
            background: 'color-mix(in srgb, var(--ds-color-neutral-900, #0f172a) 12.16%, transparent)',
          },
          '&:active': {
            background: 'color-mix(in srgb, var(--ds-color-neutral-900, #0f172a) 32.16%, transparent)',
          },

          '&::before': {
            content: "'>'",
            color: theme.palette.common.gray600,
            position: 'absolute',
            width: 4.75,
            height: 8,
            left: 12,
            top: '30%',
          },

          '&$expanded': {
            background: theme.palette.common.gray100,
            '&:hover': {
              background: 'color-mix(in srgb, var(--ds-color-neutral-900, #0f172a) 12.16%, transparent)',
            },
            '&::before': {
              position: 'absolute',
              width: 4.75,
              height: 8,
              left: 17,
              top: '40%',
              transform: 'rotate(90deg)',
            },
          },
        },
  content: {
    margin: 0,
    '&$expanded': {
      margin: 0,
      '& > *:first-child': {
        fontWeight: 400,
      },
    },
  },
  expanded: {},
}))(ExpansionPanelSummary);
AccordionSummary.defaultProps = {
  disableRootStyles: false,
};
export default AccordionSummary;
